module.exports = __webpack_public_path__ + "static/media/2.af7ae45d.jpg";